<div class="flex h-full flex-col items-center justify-center bg-surface-page">
  @if (mode) {
    <div
      class="w-full {{
        mode === 'manager' ? 'md:w-[800px]' : 'md:w-[500px]'
      }} bg-surface-page rounded-lg shadow-xl overflow-hidden"
      [ngClass]="{ anonymous__box__large: mode === 'manager' }"
    >
      <div class="padding-[12px] flex h-[60px] items-center justify-center bg-brand text-center text-brand-inverted">
        <sb-logo class="w-40" [variant]="'wordmark'" [onBrand]="true" />
      </div>
      @if (mode === 'employee') {
        <div class="p-6">
          <h3 class="anonymous__title">{{ 'Your account has been locked' | translate }}</h3>
          <p>{{ 'Your account is temporarily unavailable and cannot be accessed.' | translate }}</p>
        </div>
      }
      @if (mode === 'manager') {
        <div class="p-6">
          <h3 class="anonymous__title">{{ 'Your account has been locked because of overdue payments' | translate }}</h3>
          <p>
            {{
              'Your account is temporarily unavailable and cannot be accessed because of overdue payments. This page shows a list of expired invoices. These invoices can be paid by using the links below. Processing of these invoices can take some time, after which access to your account will be restored.'
                | translate
            }}
          </p>
          <sb-card>
            <sb-card-header>
              <h4 sb-card-title>{{ 'Invoice overview' | translate }}</h4>
            </sb-card-header>
            <sb-card-content>
              <div class="overflow-x-auto">
                <table class="table-border">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{{ 'Invoice number' | translate }}</th>
                      <th>{{ 'Date' | translate }}</th>
                      <th>{{ 'Expiration date' | translate }}</th>
                      <th>{{ 'Total amount' | translate }}</th>
                      <th>{{ 'Access code' | translate }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (invoice of unpaidInvoices; track invoice) {
                      <tr>
                        <td></td>
                        <td>{{ invoice.invoice_number }}</td>
                        <td>{{ invoice.created }}</td>
                        <td>{{ invoice.due_date }}</td>
                        <td>
                          {{ invoice.total | money: null : null : { currencyCode: invoice?.currency_code } }}
                        </td>
                        <td>{{ invoice.access_code }}</td>
                        @if (invoice.status !== 'uncollectible') {
                          <td>
                            <button
                              sb-button
                              color="primary"
                              class="float-right"
                              [sbLadda]="isInvoicePaymentPageLoading[invoice.id]"
                              (click)="openInvoice(invoice)"
                            >
                              {{ 'View and pay' | translate }}
                            </button>
                          </td>
                        }
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </sb-card-content>
          </sb-card>
        </div>
      }
    </div>
  }
  <div class="mt-6 text-center text-subtle">
    <a (click)="backToLogin()">{{ 'Back to login' | translate }}</a>
  </div>
</div>
